import { Text } from '@interco/inter-ui/components/Text'
import IcInfo from '@interco/icons/build-v4/bidis/Icons/info'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const ContentText: Content[] = [
  {
    title: 'Contratos de crédito',
    description: `Dados do contrato, data da contratação, data do recebimento do crédito, valor do crédito, data de vencimento, datas de pagamento das parcelas, período recorrente dos pagamentos, datas de vencimento da primeira e da última parcela, saldo devedor, prazo total, prazo remanescente, quantidade de prestações, prestações taxas de juros, Custo Efetivo Total, sistema de amortização, tarifas, Sigla identificadora da tarifa, encargos, garantias, número do documento da instituição consignante.`,
  },
]

export const CreditOperations = () => (
  <S.Container>
    <Text variant="body-2" style={{ fontSize: 16 }}>
      Estes serão os dados compartilhados:
    </Text>

    <S.Notice>
      <IcInfo height={32} width={32} color="var(--gray500)" />
      <Text variant="body-3" bold colorWeight={500}>
        A autorização incluirá os dados das novas contratações e operações.
      </Text>
    </S.Notice>

    {ContentText.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500}>
          {content.title}
        </Text>
        <Text variant="body-2">{content.description}</Text>
      </S.Content>
    ))}
  </S.Container>
)
